import { encodePaginatableQuery, PaginatableQuery } from '@/services/api/request/query';
import * as q from '@/services/api/request/query';

export interface CourseReportQuery extends PaginatableQuery {
  search: string;
}

export const encodeCourseReportQuery = (query: CourseReportQuery) => ({
  ...encodePaginatableQuery(query),
  search: q.string(query.search),
});
